import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'
import { PrintModal } from './PrintModal'

export function OutWarehouseList() {
    return (
        <>
            <PageHeader />
            <DataBox />
            <PrintModal />
        </>
    )
}
